import React from "react";
import PropertyBase from "../../../../common/PropertyBase";

export default function Property() {
  return (
    <PropertyBase damaged={true} formKey="info.damageToProperty.property" />
  );
}
